import $http from '../../axios';
import {Notification} from "element-ui";
export async function fetchContacts({ commit, state, rootState }) {
    let params = { params: state.params_contacts};
    await $http
        .get("/api/terceros", params)
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchChecksStatus({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/063")
        .then(response => {
            commit("setCheckState", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}
export async function getReportData({ state, commit }) {

    state.loading.form = true ;
    await $http
        .get("/api/reporte-consignacion-cheques", { params : state.params})
        .then(response => {
            commit("setReportDataConsigned", response.data);
            state.loading.form = false ;
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            state.loading.form = false ;
        });
}
export async function updateObservationReport({ state, commit },params) {
    await $http
        .post("/api/actualizar-observacion-forma-pago", params)
        .then(response => {

            Notification.success({
                title: "Success!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function getAuxAccounts({ state, commit }) {
    let params = {
        notAux:false,
        onlyAux:false,
        paginate:false,
        bank_only:true
    }
    await $http
        .get("/api/cuentas",{params}).then(response => {
            commit("setAuxiliaryAccounts", response.data.data);
        })
        .catch(error => {

        });
}
export async function searchchconsecutive({commit, state}, data) {
    await $http.get('/api/tipos-de-comprobantes/'+data.voucherType_id, {params:data})
        .then((response) => {
            commit('setConsecutive', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function createVouchers({commit , state},document_payment_id = null){
    state.loading_modal = true

    await $http.post('/api/comprobantes-varios', state.payload)
        .then((response)=>{
            state.loading_modal = false
            state.payload.document_id = response.data.data.document.id
            commit('updateVoucherPayload', response.data.data)

            commit('setConsignedData', {
                document_payment_id: state.payload.document_transaction.document_payment_id,
                document_transaction_id: null,
                account_id: null,
                observation: state.payload.document_transaction.observation
            })

        })
        .catch((error)=>{
            state.loading_modal = false
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function finalizeAccountingDocument({commit , state, dispatch}){
    state.loading_modal = true
    state.payload.pending_consigned = state.pending_consigned
    await $http.post('/api/finalizar-documento-contable', state.payload)
        .then((response)=>{
            state.loading_modal = false
            commit('setFinalizeVoucher', response.data.data)
        })
        .catch((error)=>{
            state.loading_modal = false
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        })
}
export async function downloadDocument({state}, documentToPdf) {
    let name = documentToPdf.code_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'
    let url = '/api/documentos/descargar-pdf/' + documentToPdf.document_id


    await $http({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}
export async function accountingDocCheck({commit, state, dispatch}, document_id){
    await $http.get(`/api/documento/contabilizar/${document_id}`)
        .then(response => {
            dispatch('getReportData');
        })
        .catch(error => {
            dispatch('getReportData');
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 4500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/check-consignment/actions.js